import React, { useEffect } from "react";
import { Placeholder, VisitorIdentification } from "@sitecore-jss/sitecore-jss-react";
import { withRouter } from "react-router-dom";
import Helmet from "react-helmet";
import Modal from "../components/Modal";
import Transition from "../transitions/index";
import config from "../temp/config";
import { connect } from "react-redux";
import UseQuery from "../utils/useQuery";
import { selectCookieBannerState, selectHeaderHeight, selectMarketBannerState, selectUserState, selectModelShow } from "../selectors/application";
import { canUseDOM, injectScript, isBizNull, gtag, injectGTM } from "../utils";
import { loadTwitterSDK } from "../utils/twq-utils.js";
import { useParams } from "react-router-dom";
import { mobileIs } from "../utils/siteUtils";
import { LOGOUT, setStaffInfoAction } from "../redux/actions";
import { resetActiveTime } from "../utils/autoLogout";
import _ from "lodash";
import { S_AUTH_TOKEN, S_LANG, S_PRIVACY_ID, S_COOKIE_VERSION, webStorage } from "../utils/webStorage";
// import { startCheckCart, stopCheckCart } from "../services/cartService";
import { cartInfoSelector } from "../selectors/gears-checkout";
import { setDisabledSkuidsAction } from "../redux/actions/gears-checkout";
import { AuthenticationState, AzureAD } from "react-aad-msal";
import { authProvider } from "../services/authProvider";
import store from "../redux/store/store";
import { apiAsia } from "../utils/api-asia";
import "../styles/main.scss";
import "swiper/swiper.scss";
import "../assets/app.css";
import { useHistory } from "react-router";
const crypto = require("crypto");
const isClientSide = canUseDOM();
let gtmInjected = false;
let gaInjected = false;
let gaPromise = null;

/*
  APP LAYOUT
  This is where the app's HTML structure and root placeholders should be defined.

  All routes share this root layout by default (this could be customized in RouteHandler),
  but components added to inner placeholders are route-specific.
*/
const Layout = ({ route, context, path, lang, noHeaderFooter, server, routeDataIsChanging, showMarketBanner, showCookieBanner, headerHeight, user, cartInfo, setDisabledSkuIds, setStaffInfo, logout, match, history, showModel }) => {
  const { loginRequired, loginLink, sessionValidity, pageType, rtl } = route.fields;

  const params = useParams();
  const htmlAttributes = { lang };
  if (rtl?.value) {
    htmlAttributes.dir = "rtl";
  }
  const isMobile = mobileIs();
  webStorage.set(S_LANG, lang);
  const loadGTM = async page => {
    if (!gtmInjected && context.siteConfig && context.siteConfig.gtmIds) {
      injectGTM(context.siteConfig.gtmIds);
      gtmInjected = true;
    }
  };
  useEffect(() => {
    loadGTM(path);
  }, [path]);
  const loadGA = async page => {
    if (!gaInjected && context.siteConfig && context.siteConfig.gaId) {
      window.dataLayer = window.dataLayer || [];
      gaPromise = injectScript(`https://www.googletagmanager.com/gtag/js?id=${context.siteConfig.gaId}`, () => !!gaInjected);
      gaInjected = true;
      await gaPromise;
      gaPromise = null;
      gtag('js', new Date());
      gtag('config', context.siteConfig.gaId);
    }
    if (gaPromise) {
      await gaPromise;
    }
    return window.dataLayer;
  };
  useEffect(() => {
    loadGA(path);
    if (isClientSide) {
      // let TwitterCode = route.fields.TwitterCode.fields.ConfigCode.value;
      // const twq = loadTwitterSDK(TwitterCode);
    }
  }, [path]);
  useEffect(() => {
    let dom = document.querySelectorAll(".IframePage")[0];
    let containerDom = document.querySelectorAll(".components-container")[0];
    if (isMobile) {
      if (dom !== undefined) {
        containerDom.style.height = "100%";
      } else {
        containerDom.style.height = "auto";
      }
    } else {
      containerDom.style.height = "auto";
    }
  }, [route]);
  useEffect(() => {
    let loadId = "";
    const script = document.createElement("script");
    apiAsia.form.ip({ language: lang }).then(res => {
      if (!!res[0]) {
        let code = res[0].countryCode;
        if (code == "SA" || code == "QA" || code == "AE" || code == "BH") {
          loadId = "CHJE47JC77U0O25EFMJG";
        }
        if (code == "KW") {
          loadId = "CHJE68RC77U7QBTLU3N0";
        }
        if (code == "OM") {
          loadId = "CHJE68RC77U7QBTLU3N0";
        }
        script.innerHTML = `
        !function (w, d, t) {
          w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track123","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};var o=document.createElement("script");o.type="text/javascript",o.async=!0,o.src=i+"?sdkid="+e+"&lib="+t;var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(o,a)};
        
          ttq.load('${loadId}');
          ttq.page();
        }(window, document, 'ttq');
        `;
        document.head.appendChild(script);
      }
    });

    const query = UseQuery();
    if (query.skey && query.act !== "unsub") {
      apiAsia.form.visit({ skey: query.skey });
    }

    return () => {
      document.head.removeChild(script);
    };
    //Market redirect
    // const marketRedirect = window.localStorage.getItem("marketRedirect");
    // if (marketRedirect) {
    //   history.push(`/${match.params.lang}${marketRedirect}`);
    //   window.localStorage.removeItem("marketRedirect");
    // }
  }, []);

  useEffect(() => {
    // if (!routeDataIsChanging) {
    let { isShow } = route.fields;
    let timer = setInterval(() => {
      let cht_desktop_e = document.querySelector(".lp_desktop");
      let LPMcontainer = document.querySelector(".LPMcontainer");
      if (LPMcontainer || cht_desktop_e) {
        clearInterval(timer);
      }
      if (isShow && isShow.value) {
        if (LPMcontainer) {
          LPMcontainer.style.display = "none";
        }
        if (cht_desktop_e) {
          cht_desktop_e.style.display = "block";
        }
      } else {
        if (LPMcontainer) {
          LPMcontainer.style.display = "none";
        }
        if (cht_desktop_e) {
          cht_desktop_e.style.display = "none";
        }
      }
      if (noHeaderFooter) {
        if (LPMcontainer) {
          LPMcontainer.style.display = "none";
        }
        if (cht_desktop_e) {
          cht_desktop_e.style.display = "none";
        }
      }
    }, 300);
    // const token = webStorage.get(S_AUTH_TOKEN);
    // if (token) {
    //   if (Date.now() > token.expiresTime * 1000) {
    //     logout();
    //     return;
    //   } else {
    //     resetActiveTime(sessionValidity.value);
    //   }
    // }
    // if (loginRequired.value) {
    //   if (!loginLink.value) {
    //     console.error("login link should be configurated");
    //   } else {
    //     let loginUrl = loginLink.value.href;
    //     if (!loginUrl) {
    //       loginUrl = `/${lang}/login`;
    //     }
    //     if (isBizNull(user)) {
    //       const { pathname, search, hash } = global.location;
    //       global.location.href = `${loginUrl}?redirect=${encodeURIComponent(`${pathname}${search}${hash}`)}`;
    //     }
    //   }
    // }
    //** Measurements */
    let dataLayer = window.dataLayer || [];
    let cryptedEmail = user?.email
      ? crypto
        .createHash("sha256")
        .update(user.email)
        .digest("hex")
      : "";
    let _user = {
      id: user ? user.id : "",
      customer_number: user ? user.customerNumber : "",
      email_sha256: cryptedEmail,
      logged_in: user ? "1" : "0"
    };
    let _currency = "EUR";
    let _country = lang.indexOf("-") > -1 ? lang.split("-")[1] : "se";
    if (_country === "se") {
      _currency = "SEK";
    }
    let _page = {
      type: pageType,
      currency: _currency,
      country: lang
    };
    dataLayer.push({
      event: "init",
      page: _page,
      user: _user
    });
  }, [route, user]);
  if (loginRequired.value && isBizNull(user)) {
    return null;
  }

  return (
    <React.Fragment>
      {/* react-helmet enables setting <head> contents, like title and OG meta tags 12*****12 */}
      <Helmet htmlAttributes={htmlAttributes}>
        <meta name="description" content={(route.fields && route.fields.pageDescription && route.fields.pageDescription.value) || "description"} />
        <meta name="Keywords" content={(route.fields && route.fields.pageKeywords && route.fields.pageKeywords.value) || ""} />
        {/* canonical */}
        {(route.fields.canonical &&
          route.fields.canonical.value &&
          route.fields.canonical.value
            .split("<link")
            .filter(item => item.trim().length > 0)
            .map((item, index) => {
              let rel = item.match(/rel=[\'|\"]([^']*?)[\'|\"]/),
                href = item.match(/href=[\'|\"]([^']*?)[\'|\"]/);
              rel = rel && rel.length ? rel[rel.length - 1] : "";
              href = href && href.length ? href[href.length - 1] : "";
              return <link rel={rel} href={href} key={index} />;
            })) || <link rel="canonical" href={canonical({ path, lang })} />}
        {/* hreflang */}
        {(route.fields.hreflang &&
          route.fields.hreflang.value &&
          route.fields.hreflang.value
            .split("<link")
            .filter(item => item.trim().length > 0)
            .map((item, index) => {
              let rel = item.match(/rel=[\'|\"]([^']*?)[\'|\"]/),
                href = item.match(/href=[\'|\"]([^']*?)[\'|\"]/),
                hreflang = item.match(/hreflang=[\'|\"]([^']*?)[\'|\"]/);
              rel = rel && rel.length ? rel[rel.length - 1] : "";
              href = href && href.length ? href[href.length - 1] : "";
              hreflang = hreflang && hreflang.length ? hreflang[hreflang.length - 1] : "";
              return <link rel={rel} href={href} key={index} hrefLang={hreflang} />;
            })) || <link rel="alternate" hrefLang="en" href={`${config.webSettings.WebSiteHost + "/"}${path.replace(new RegExp(`/${lang}$|/${lang}/`, "i"), "/").toLowerCase()}`} />}

        {route.fields.noindex && route.fields.noindex.value && <meta name="robots" content="noindex" />}
        {route.fields.nofollow && route.fields.nofollow.value && <meta name="robots" content="nofollow" />}
        <noscript>{route.fields.richSnippets && route.fields.richSnippets.value}</noscript>
        <title>{(route.fields && route.fields.pageTitle && route.fields.pageTitle.value) || ""}</title>
      </Helmet>
      <VisitorIdentification />

      {(!loginRequired.value || (loginRequired.value && user)) && (
        <div style={{ display: server === true ? "none" : "block", height: "100%" }}>
          {!noHeaderFooter && (
            <React.Fragment>
              <Placeholder name="jss-header" rendering={route} pathname={path} lang={lang} page={route} />
            </React.Fragment>
          )}
          {/* {route.fields && route.fields.gtmId && route.fields.gtmId.value && (
          <GoogleTagManager gtmId={route.fields.gtmId.value} />
        )} */}
          {/* root placeholder for the app, which we add components to using route data */}
          <div className={"components-container root"} style={{ marginTop: !noHeaderFooter ? "" : "0px", opacity: showModel ? 0 : 1 }}>
            <Placeholder name="jss-main" rendering={route} pathname={path} lang={lang} page={route} match={match} server={server} />
          </div>
          <Modal id="jss-model-id">
            <Placeholder name="jss-modal" rendering={route} pathname={path} lang={lang} page={route} />
          </Modal>

          {!noHeaderFooter && <Placeholder name="jss-footer" rendering={route} pathname={path} lang={lang} page={route} />}
          {isClientSide && (showMarketBanner || showCookieBanner) && (
            <div
              style={{
                width: "100%",
                // top: `${headerHeight}px`,
                bottom: isMobile ? "20px" : "0px",
                position: "fixed",
                zIndex: 10
              }}
              className={showMarketBanner && showCookieBanner ? "market-cookie-container-both-showing" : ""}
            >
              <Placeholder name="jss-cookies" rendering={route} pathname={path} lang={lang} page={route} />
            </div>
          )}
        </div>
      )}
      <Transition />
      {isClientSide && (
        <AzureAD provider={authProvider} reduxStore={store}>
          {({ accountInfo, authenticationState }) => {
            if (authenticationState === AuthenticationState.Authenticated) {
              setStaffInfo(accountInfo);
            } else {
              setStaffInfo(null);
            }
            return null;
          }}
        </AzureAD>
      )}
    </React.Fragment>
  );
};
let canonical = ({ path, lang }) => {
  let defaultLanguage = config.defaultLanguage;
  let result = config.webSettings.WebSiteHost + path;
  //let result = config.sitecoreApiHost + path;
  if (lang !== defaultLanguage) {
    result = config.webSettings.WebSiteHost + path;
  }
  result = result.toLowerCase();
  return result;
};
const mapStateToProps = state => {
  return {
    showMarketBanner: selectMarketBannerState(state),
    showCookieBanner: selectCookieBannerState(state),
    headerHeight: selectHeaderHeight(state),
    showModel: selectModelShow(state),
    user: selectUserState(state),
    cartInfo: cartInfoSelector(state)
  };
};
const mapDispatchToProps = dispatch => ({
  logout: (...args) => dispatch({ type: LOGOUT, ...args }),
  setDisabledSkuIds: data => dispatch(setDisabledSkuidsAction(data)),
  setStaffInfo: data => dispatch(setStaffInfoAction(data))
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Layout));
